export default __webpack_public_path__ + "static/excavators-jcb-bc84b26133851b39336c290a58567c5e.png";